module.exports = __webpack_public_path__ + "media/images/icons/headphones-7d810d3e2f2cdb53f86b00966fea92f4.svg";